module.exports = __webpack_public_path__ + "static/media/mid-section.cade0118.jpg";